import { css } from 'linaria';
import { styled } from 'linaria/react';

export const projectCardContainer = css`
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
  box-sizing: border-box;
  height: 164px;
  padding: var(--space-250);
  scroll-snap-align: start;
  background-color: var(--background-secondary);
  border-radius: 12px;
  transition: transform 0.3s ease;
`;

export const cardHeader = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--space-150);
`;

export const cardFooter = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-150);
  margin-top: auto;
`;

export const imagesContainer = css`
  display: flex;
  flex: 3;
  flex-wrap: nowrap;
  gap: var(--space-100);
  overflow: hidden;
`;

export const projectImage = css`
  border-radius: var(--space-100);
  object-fit: cover;
`;

export const projectPrice = css`
  flex: 1;
  white-space: nowrap;
`;

export const СardTitleContainer = styled.div`
  > span {
    display: -webkit-box;
    flex: 1;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    margin-bottom: var(--space-150);
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
  }
`;
